import api from '@/utils/api';
import {
    GET_ORTHODONTIC_EXAM_BY_CUSTOMER,
    CREATE_SPECIFIC_ORTHODONTIC_EXAM,
    UPDATE_SPECIFIC_ORTHODONTIC_EXAM,
    REMOVE_ORTHODONTIC_EXAM,
    GET_SPECIFIC_ORTHODONTIC_EXAM
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy thông tin khám chỉnh nha theo khách hàng
 */
export const getOrthodonticExamByCustomer = (filter, customerId) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/orthodontic-exams/customer/${customerId}`, { params: filter })
            .then(res => {
                dispatch({
                    type: GET_ORTHODONTIC_EXAM_BY_CUSTOMER,
                    payload: res.data.data
                });
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
    });
};

/**
 * Lấy TBản ghi cụ thể theo ID
 */
export const getSpecificOrthodonticExam = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/orthodontic-exams/${id}`)
            .then((res) => {
                dispatch({ type: GET_SPECIFIC_ORTHODONTIC_EXAM, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể lấy chi tiết Treatment Session'
                );
                reject(err);
            });
    });
};

/**
 * Cập nhật hoặc tạo mới thông tin khám chỉnh nha
 */
export const createOrthodonticExam = (customerId, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post(`/orthodontic-exams/customer/${customerId}`, data)
            .then(res => {
                dispatch({
                    type: CREATE_SPECIFIC_ORTHODONTIC_EXAM,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Tạo phiếu khám chỉnh nha thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Có lỗi xảy ra khi cập nhật!');
                reject(err);
            });
    });
};

/**
 * Cập nhật hoặc tạo mới thông tin khám chỉnh nha
 */
export const updateOrthodonticExam = (customerId, id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/orthodontic-exams/customer/${customerId}/${id}`, data)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_ORTHODONTIC_EXAM,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Cập nhật phiếu khám chỉnh nha thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Có lỗi xảy ra khi cập nhật!');
                reject(err);
            });
    });
};

/**
 * Duyệt phiếu khám chỉnh nha
 */
export const approveOrthodonticExam = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/orthodontic-exams/approve/${id}`)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_ORTHODONTIC_EXAM,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Đã xác nhận phiếu khám chỉnh nha!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể duyệt phiếu!');
                reject(err);
            });
    });
};

/**
 * Hủy duyệt phiếu khám chỉnh nha
 */
export const unapproveOrthodonticExam = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/orthodontic-exams/unapprove/${id}`)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_ORTHODONTIC_EXAM,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Đã hủy xác nhận phiếu khám chỉnh nha!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể hủy duyệt phiếu!');
                reject(err);
            });
    });
};


/**
 * Xoá một hoặc nhiều bản ghi
 */
export const removeOrthodonticExam = (ids) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .delete('/orthodontic-exams', { data: { ids } })
            .then((res) => {
                dispatch({ type: REMOVE_ORTHODONTIC_EXAM, payload: ids });
                NotificationManager.success('Xoá thành công!');
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Xoá thất bại'
                );
                reject(err);
            });
    });
};